import { action, observable } from 'mobx';

import { AuctionFinalsStore } from 'components/AuctionFinals/stores';

import Step1 from './Step1';
import Step2 from './Step2';
import Info from './Info';
import Summary from './Summary';

export default class Store {
  @observable loading = false;
  @observable loaded = false;

  steps = [
    {
      key: 'winners',
      title: 'Choose winners',
      implementation: Step1,
      info: Info,
    },
    {
      key: 'review',
      title: 'Review winners',
      implementation: Step2,
      info: Info,
    },
  ];

  auctionFinalsStore = null;
  summaryClass = Summary;

  constructor(management) {
    this.management = management;
    this.auctionFinalsStore = new AuctionFinalsStore(management.source);
  }

  @action async submit(saleId, token) {
    await this.auctionFinalsStore.awardAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/AwardAll/index.js